import { useQuery } from '@tanstack/react-query';
import { getVideos } from '../services/admin/admin-video.service';
import { ADMIN_VIDEOS_KEY } from '../common/utils/video-query-cache';
import { VideoPlacementValues } from '../common/model/type/video-placement.types';
import { NO_PLACEMENT } from '../common/model/dto/video/video-constants';
import { isValidPosition } from '../common/utils/video-placement-utils';

export function usePlacementOrderConflict(
  videoId: string,
  { placement_key, position }: VideoPlacementValues,
  isEnabled: boolean
): boolean {
  const isPlaced = placement_key !== NO_PLACEMENT;
  const query = { placement_key, limit: 0 };

  const { data } = useQuery({
    queryKey: [ADMIN_VIDEOS_KEY, query],
    queryFn: () => getVideos(query),
    enabled: isEnabled && isPlaced,
  });

  if (!isPlaced || !isValidPosition(position) || !data) {
    return false;
  }

  const order = Number(position.trim());

  return data.docs.some(
    (other) => other.id !== videoId && other.position === order
  );
}
